import { Injectable } from '@angular/core';
import { ActivatedRoute, UrlTree } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class RoutingService {
  private navStartUrl?: UrlTree | undefined;

  get startUrl(): UrlTree | undefined {
    if (typeof this.navStartUrl === 'undefined') {
      return undefined;
    }

    const url = this.navStartUrl.toString();

    // This avoids loops when saving routing
    if (url.includes('auth') || url === '/' || url === '') {
      return undefined;
    }

    return this.navStartUrl;
  }

  set startUrl(url: UrlTree | undefined) {
    // Set behavior in the routing service depending on the url route
    if (url && url?.queryParams?.assignLeadUid) {
      this.assignLeadToUser = true;
    }

    this.navStartUrl = url;
  }

  public assignLeadToUser: boolean = false;

  async getSelectedAccountUid(route: ActivatedRoute): Promise<string> {
    const accountUid = await this.getQueryParamsByName('accountUid', route);

    // If an account UID is provided, if it does not match what is in local storage then set it
    if (accountUid && accountUid !== localStorage.getItem('accountUid')) {
      localStorage.setItem('accountUid', accountUid);
    }
    return accountUid as string;
  }

  async getQueryParamsByName(paramName: string, route: ActivatedRoute): Promise<string | undefined> {
    let param;

    // @ts-ignore
    const params = { ...route.params.value, ...route.parent?.params.value };

    // Fallback to localstorage (accountUid, userUid)
    if (!params[paramName]) {
      param = localStorage.getItem(paramName);
    }

    return params[paramName] ?? param;
  }
}
